module.exports = __webpack_public_path__ + "8264eb16475f6d707dc9af8d39dbb873.pdf";